import { render, staticRenderFns } from "./ServiceCodeToothNumberAllowed.vue?vue&type=template&id=2083bbb9"
import script from "./ServiceCodeToothNumberAllowed.vue?vue&type=script&lang=js"
export * from "./ServiceCodeToothNumberAllowed.vue?vue&type=script&lang=js"
import style0 from "./ServiceCodeToothNumberAllowed.vue?vue&type=style&index=0&id=2083bbb9&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports